module.exports = __webpack_public_path__ + "img/10.8f35c7c2.png";